const initialState = {
  fansData: [],
  fanLastDocument: "",
  hasMoreDocumentFanData: true,
  states: [],
  fanStats: {},
  fanSurvey: {},
};

const fanDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_STATS_FAN":
      return {
        ...state,
        fanStats: action.payload,
      };
    case "GET_STATES":
      return {
        ...state,
        states: action.payload,
      };
    case "IS_FAN_BLOCK":
      let { block, id } = action.payload;
      let updatePlayer = state.fansData.map((items) =>
        items.id == id ? { ...items, blocked: block } : items
      );
      return {
        ...state,
        fansData: updatePlayer,
      };
    case "GET_FANS_DATA":
      return {
        ...state,
        fansData: action.payload.data,
        fanLastDocument: action.payload.lastDocument,
        hasMoreDocumentFanData: action.payload.hasMoreDocument,
      };
    case "GET_FANS_DATA_MORE":
      return {
        ...state,
        fansData: [...state.fansData, ...action.payload.data],
        fanLastDocument: action.payload.lastDocument,
        hasMoreDocumentFanData: action.payload.hasMoreDocument,
      };
    case "GET_FANS_SURVEY":
      return {
        ...state,
        fanSurvey: action.payload.survey_data,
      };
    default:
      return state;
  }
};

export default fanDataReducer;
